import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const ArrowRight = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <path
        d='m13.94 18.708 6.06-6m0 0-6.06-6m6.06 6H4'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M13.406 6.18a.75.75 0 0 1 1.004-.056l.057.05 6.06 6a.75.75 0 0 1 0 1.067l-6.06 6a.75.75 0 0 1-1.055-1.066l4.765-4.717H4a.75.75 0 1 1 0-1.5h14.177L13.412 7.24l-.052-.056a.75.75 0 0 1 .046-1.004'
        fill='currentColor'
      />
    )}
  </IconBase>
);
